module.exports = __webpack_public_path__ + "static/media/030-north-korea.bc191f10.svg";